module.exports = __webpack_public_path__ + "static/img/qq.ad4c9453.png";